import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchReportByDay } from "./reportAPI";

const initialState = {};
const reducers = {};

export const reportsThunk = createAsyncThunk('reports/load', async ()=>{
    const payload = await fetchReportByDay();
    return payload;
});

const reportSlice = createSlice({
    name: 'reports',
    initialState,
    reducers,
    extraReducers: (builder)=>{
        builder
            .addCase(reportsThunk.fulfilled, (state, action)=> ({ ...action.payload }))
    }
});

export default reportSlice.reducer;